export const APPLIED_FILTERS_PLACEHOLDER = Symbol('Applied filters placeholder');
export const SAVED_FILTERS_PLACEHOLDER = Symbol('Saved filters placeholder');
